import { render } from "./svg-play.vue?vue&type=template&id=0372fd23"
import script from "./svg-play.vue?vue&type=script&lang=ts"
export * from "./svg-play.vue?vue&type=script&lang=ts"
script.render = render

export default script